module.exports = __webpack_public_path__ + "static/20gde-afeb246a4a0d6f2cda131a4d674f8194.gif";